module.exports = __webpack_public_path__ + "img/pro_mega10_02.556211aa.png";